var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 161"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 257",
    fill: "#566270",
    d: "M6.654 24.335h21.863v3.992H6.654z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 258",
    fill: "#4570a9",
    d: "M0 18.251h23.955v3.992H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 259",
    fill: "#4570a9",
    d: "M25.222 18.251h6.464v3.992h-6.464z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 260",
    fill: "#00a2ce",
    d: "M4.563 12.167H16.16v3.992H4.563z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 261",
    fill: "#00a2ce",
    d: "M17.728 12.167h5.228v3.992h-5.228z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 262",
    fill: "#6acaff",
    d: "M8.365 6.084h19.392v3.992H8.365z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 263",
    fill: "#9addff",
    d: "M7.319 0h16.35v3.992H7.319z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 264",
    fill: "#9addff",
    d: "M.285 0h5.228v3.992H.285z"
  }))))));
}

export default SvgIcon;